module.exports = __webpack_public_path__ + "static/img/pic-bg-active-5.6ea8681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-active-5.png
// module id = lWl7
// module chunks = 0